<template>
  <div>
    <q-header elevated class="bg-primary">
      <q-toolbar>
        <q-btn flat @click="drawer = !drawer" round dense icon="menu"></q-btn>
        <q-toolbar-title style="font-family: 'Outfit', sans-serif">
          <!-- <q-img
            src="/statics/TDRI_Logo_Light.png"
            spinner-color="white"
            style="height: 40px; width: 100px"
            contain
          >
          </q-img> -->
          TDRI
        </q-toolbar-title>
        <q-btn-dropdown
          v-if="currentUserData.role != 'Admin'"
          flat
          :loading="switchOrgLoading"
          :label="currentUserData.currentPermissions.name"
        >
          <q-list>
            <q-item
              v-for="(org, index) in currentUserData.permissions"
              :key="`org_${index}`"
              clickable
              v-close-popup
              @click="switchOrg(org)"
            >
              <q-item-section>
                <q-item-label>{{ org.name }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </q-toolbar>
    </q-header>

    <q-drawer v-model="drawer" show-if-above :width="200" :breakpoint="400">
      <q-scroll-area
        style="
          height: calc(100% - 150px);
          margin-top: 150px;
          border-right: 1px solid #ddd;
        "
      >
        <q-list padding class="text-accent">
          <!-- <q-item v-ripple to="/" exact>
            <q-item-section avatar>
              <q-icon name="dashboard"></q-icon>
            </q-item-section>

            <q-item-section>
              Dashboard
            </q-item-section>
          </q-item> -->
          <q-item v-ripple to="/surveys" exact>
            <q-item-section avatar>
              <q-icon name="mdi-clock"></q-icon>
            </q-item-section>

            <q-item-section> Scheduled Surveys </q-item-section>
          </q-item>

          <q-item v-ripple to="/reporting" exact>
            <q-item-section avatar>
              <q-icon name="mdi-chart-box"></q-icon>
            </q-item-section>

            <q-item-section> Past Surveys </q-item-section>
          </q-item>
          <q-item
            v-if="currentUserData.role == 'Admin'"
            v-ripple
            to="/merging"
            exact
          >
            <q-item-section avatar>
              <q-icon name="mdi-merge"></q-icon>
            </q-item-section>

            <q-item-section> Merge Surveys </q-item-section>
          </q-item>

          <q-item
            v-if="currentUserData.role == 'Admin'"
            v-ripple
            to="/organizations"
            exact
          >
            <q-item-section avatar>
              <q-icon name="mdi-domain"></q-icon>
            </q-item-section>

            <q-item-section> Organisations </q-item-section>
          </q-item>
          <q-item
            v-if="currentUserData.role == 'Admin'"
            v-ripple
            to="/trailers"
            exact
          >
            <q-item-section avatar>
              <q-icon name="mdi-truck-trailer"></q-icon>
            </q-item-section>

            <q-item-section> Trailer Units </q-item-section>
          </q-item>
          <q-item
            v-if="currentUserData.role != 'OrgUser'"
            v-ripple
            to="/users"
            exact
          >
            <q-item-section avatar>
              <q-icon name="mdi-account-group"></q-icon>
            </q-item-section>

            <q-item-section>
              {{ currentUserData.role == "OrgAdmin" ? "Organisation" : "" }}
              Users
            </q-item-section>
          </q-item>
          <q-item v-ripple to="/your-profile" exact>
            <q-item-section avatar>
              <q-icon name="mdi-account"></q-icon>
            </q-item-section>

            <q-item-section> Your Profile </q-item-section>
          </q-item>
          <q-item v-ripple to="/contact" exact>
            <q-item-section avatar>
              <q-icon name="mdi-phone"></q-icon>
            </q-item-section>

            <q-item-section> Contact Tech Support </q-item-section>
          </q-item>
          <q-item
            v-if="currentUserData.role == 'Admin'"
            v-ripple
            to="/scan-reprocess"
            exact
          >
            <q-item-section avatar>
              <q-icon name="mdi-refresh"></q-icon>
            </q-item-section>

            <q-item-section> Scan Re-processing </q-item-section>
          </q-item>
          <q-item
            v-if="currentUserData.role == 'Admin'"
            v-ripple
            to="/settings"
            exact
          >
            <q-item-section avatar>
              <q-icon name="mdi-cogs"></q-icon>
            </q-item-section>

            <q-item-section> Settings </q-item-section>
          </q-item>
          <q-item
            v-if="currentUserData.role == 'Admin'"
            v-ripple
            to="/mobile-view/home"
            exact
          >
            <q-item-section avatar>
              <q-icon name="mdi-cellphone"></q-icon>
            </q-item-section>

            <q-item-section> Mobile Version </q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>

      <q-img
        class="absolute-top bg-white"
        style="
          height: 150px;
          border-right: 1px solid #dddddd;
          border-bottom: 1px solid #dddddd;
        "
      >
        <div class="absolute-bottom bg-transparent">
          <div
            class="q-pb-lg"
            style="width: 150px; margin: auto; position: relative"
          >
            <q-img
              src="/statics/TDRI_Logo_Light.png"
              spinner-color="white"
              contain
            />
          </div>

          <div class="row">
            <div class="col-10 text-black">
              <div class="text-weight-bold">
                {{ currentUserData.name }}
              </div>
              <div
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 100%;
                "
              >
                {{ currentUserData.email }}
              </div>
            </div>
            <div class="col-2">
              <q-btn
                flat
                round
                color="secondary"
                @click="$store.dispatch('logout')"
                icon="lock"
              />
            </div>
          </div>
        </div>
      </q-img>
    </q-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["currentUser", "currentUserData"]),
  },
  data: () => ({
    drawer: false,
    miniState: true,
    switchOrgLoading: false,
  }),
  components: {},
  beforeCreate() {},
  mounted() {},
  methods: {
    async switchOrg(org) {
      this.switchOrgLoading = true;
      await this.$store.dispatch("updateOrg", org.ref_id);
      this.switchOrgLoading = false;
      await this.$router.push("/");
      this.$router.go(-1);
    },
  },
};
</script>
